import React from "react";

import { To, useNavigate } from "react-router";

import { Button, type ButtonProps } from "antd";
/**
 * A link component styled to look like an AntDesign button. Useful for when you need a link that looks like a button.
 *
 * @returns
 */
function LinkButton(
    props: {
        to: To;
    } & ButtonProps
) {
    const navigate = useNavigate();

    const { to, children, onClick, ...buttonProps } = props;

    const onLinkClick: React.MouseEventHandler<HTMLElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
        navigate(to);
    };
    return (
        <Button href={to.toString()} onClick={onLinkClick} {...buttonProps}>
            <span>{children}</span>
        </Button>
    );
}

export default LinkButton;
